import { Component, Host, h, Prop } from "@stencil/core";
import pfx from "../../utils/style-class-prefix-helper";

@Component({
  tag: "eon-ui-spacer",
  styleUrl: "spacer.scss",
  shadow: true
})
export class Spacer {
  /**
   * No spacing in mobile view
   */
  @Prop() hideInPhone: boolean;

  /**
   * No spacing in tablet view
   */
  @Prop() hideInTablet: boolean;

  /**
   * No spacing in desktop view
   */
  @Prop() hideInDesktop: boolean;

  /**
   * No spacing in desktop large view
   */
  @Prop() hideInDesktopLarge: boolean;

  render() {
    return (
      <Host>
        <div
          class={pfx({
            spacer: true,
            "spacer-hidden-phone": this.hideInPhone,
            "spacer-hidden-tablet": this.hideInTablet,
            "spacer-hidden-desktop": this.hideInDesktop,
            "spacer-hidden-desktop-large": this.hideInDesktopLarge
          })}
        ></div>
      </Host>
    );
  }
}
